import { useAdministrativeContext } from "../../../../../../pages/administrativePanel/administrativePanelContext"
import { useCallback, useEffect, useState } from "react"
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { api } from '../../../../../../services/api'
import { GenericHorizontalBar } from "../../genericHorizontalBar"
import { toast } from "react-toastify"
import { useAuth } from "../../../../../../context/AuthContext"



export function PaymentTypesGraphic() {
    const [paymentTypesDatasForGraphic, setPaymentTypesDatasForGraphic] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const { signOut } = useAuth()


    const fetchData = useCallback(async () => {
        setIsLoading(true)

        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            complete: false, 
            salesChannels: listSalesChannelsId
        }

        try{
            await api.post('/getPaymentTypesGraphic' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setPaymentTypesDatasForGraphic(response.data))

            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
        
    }, [signOut, startDate, endDate, listBusinessToFilter, listSalesChannelsId])


    useEffect(() => {
        let subscribed = true

        if(subscribed && startDate !== '' && endDate !== '')
            fetchData()

        return () => (subscribed = false)
    }, [fetchData, startDate, endDate])



    if(isLoading){
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/>
    }else{
        return(
            <>
            {
                paymentTypesDatasForGraphic.length > 0 ?
                <GenericHorizontalBar datasForGraphic={paymentTypesDatasForGraphic} />
                :<p className="withoutInformations">Nenhuma informação</p>
            }
            </>
        )
    }
}